<template>
  <div class="economic_box">
    <!-- <div class="map" v-show="false">
      <MapShow ref="mapshow"></MapShow>
      
    </div> -->
    <div class="map">
      <gd-map @marker="onMarker" @complete="onComplete" ref="gdmap"></gd-map>
    </div>
    <div class="show_data">
      <div style="opacity: 0" class="time flex_end">
        Last | {{ currentCountry.date }}
      </div>
      <div class="table_show_data">
        <div class="base_info flex_between">
          <div class="country flex_start">
            <div class="country_img fi" :class="'fi-' + currentCountry.image">
              <!-- <img src="../assets/images/map.png" alt="" /> -->
            </div>
            <div class="country_name">{{ currentCountry.country }}</div>
          </div>
          <!-- <div class="flex_start canlendar_box">
            <div class="date_show">{{ dateVal }}</div>
            <div class="calendar"></div>
          </div> -->
          <div class="flex_start canlendar_box">
            <div>{{ currentCountry.date }}</div>
            <!-- <div class="calendar"></div> -->
            <!--            <div class="absolute">-->
            <!--              <el-date-picker-->
            <!--                class="data_picker"-->
            <!--                type="month"-->
            <!--                placeholder="选择日期"-->
            <!--                v-model="val"-->
            <!--              >-->
            <!--              </el-date-picker>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="table">
          <table-show
            v-loading="tableLoading"
            max-height="180"
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column prop="name" :label="$transform('NAME')">
              <template slot-scope="{ row }">
                <span class="cell_1">{{ row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="period" :label="$transform('PERIOD')">
            </el-table-column>
            <el-table-column prop="value" :label="$transform('VALUE')">
              <template slot-scope="{ row }">
                <span class="cell_2">{{ row.value }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="date" :label="$transform('VALUE DATE')">
            </el-table-column>
            <el-table-column prop="periodv" :label="$transform('PRIOR VALUE')">
            </el-table-column>
          </table-show>
        </div>
      </div>
      <div style="margin-top: 10px"><bottom-tip></bottom-tip></div>
    </div>
  </div>
</template>

<script>
// import MapShow from "@/components/map/index.vue";
import GDMap from "@/components/gd-map/index.vue";

import "flag-icons/css/flag-icons.min.css";
export default {
  components: {
    // MapShow,
    "gd-map": GDMap,
  },
  data() {
    return {
      val: "",
      tableData: [],
      originTableData: [],
      countryList: [],
      tableLoading: false,
      currentCountry: {},
      dateVal: "",
    };
  },
  computed: {
    date() {
      let [a, m, c, y] = new Date().toDateString().split(" ");
      if (this.val == "") {
        return `${m} ${y}`;
      } else {
        let [a, m, c, y] = new Date(this.val).toDateString().split(" ");
        return `${m} ${y}`;
      }
    },
  },
  watch: {
    val(n) {
      // let [a, m, c, y] = new Date(n).toDateString().split(" ");
      // this.loading = this.$loading();
      this.getCountryData(this.currentCountry.country);
      // this.tableData = [...this.originTableData].filter(
      //   (item) => item.date.indexOf(m) > -1
      // );
    },
  },
  mounted() {
    this.loading = this.$loading();
  },
  methods: {
    onComplete() {
      this.getCountry();
    },
    onMarker(e) {
      console.log(e);
      this.val = e.item.date;
      this.currentCountry = e.item;
      this.getCountryData(e.item.country);
    },
    getCountry() {
      this.$tool
        .fetchPost("/api/getCharts6TabList")
        .then((res) => {
          this.loading.close();
          if (res.code == 200) {
            let list = [];
            let contryList = res.data;
            for (let key in contryList) {
              //   longitude: 116.339924,
              // latitude: 39.887222,
              let { 经度, 纬度, images, date } = contryList[key];
              list.push({
                country: key,
                longitude: 经度,
                latitude: 纬度,
                image: images, //this.$getCountryISO2(key),
                date,
              });
            }
            this.currentCountry = list[0];
            this.getCountryData(list[0].country);
            this.countryList = list;
            this.$refs.gdmap.addMarker(list);
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading.close();
        });
    },
    getCountryData(type) {
      this.tableLoading = true;
      return this.$tool
        .fetchPost("/api/getCharts6TabData", { type, date: this.date })
        .then((res) => {
          this.tableLoading = false;
          if (res.code == 200) {
            this.tableData = res.data;
            this.originTableData = res.data;
            if (res.data.length) {
              this.dateVal = res.data[0].date;
            }
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$max-width: 500px;
.economic_box {
  position: relative;
  @media screen and (max-width: $max-width) {
    width: 100%;
    height: 100vh;
  }
  .map {
    width: 81%;
    @media screen and (max-width: $max-width) {
      width: 100%;
    }
  }
  .show_data {
    width: 40%;
    max-width: 700px;
    height: auto;
    position: absolute;
    top: 10px;

    right: 0;
    @media screen and (max-width: $max-width) {
      width: 90%;
      max-width: 90%;
      top: unset;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
      right: unset;
    }
    .table_show_data {
      border: 1px solid #e5e5e5;
    }
    ::v-deep .el-date-editor .el-icon-circle-close {
      display: none;
    }
    ::v-deep .el-input--prefix .el-input__inner {
      cursor: pointer;
    }
    .time {
      font-size: 12px;
      font-weight: 300;
      color: #333333;
      margin-bottom: 10px;
    }
    .base_info {
      width: 100%;
      height: 75px;
      background-color: #f8f8f8;
      box-sizing: border-box;
      padding: 0 9px;
      border-bottom: 1px solid #e5e5e5;
      .country {
        font-size: 18px;
        font-weight: 300;
        color: #3d3d3d;
        .country_name {
          font-size: 32px;
          color: #002f6c;
          font-family: SF-Pro-Display-Heavy;
          font-weight: 300;
        }
        .country_img {
          width: 65px;
          height: 44px;
          margin-right: 15px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .canlendar_box {
        font-size: 14px;
        font-weight: 300;
        color: #333333;
        position: relative;
        cursor: pointer;
        .date_show {
          font-weight: 300;
          color: #4a4a4a;
        }
        .calendar {
          width: 18px;
          height: 18px;
          background: url("../assets/images/calendar.png") no-repeat center
            center;
          background-size: 100% 100%;
          margin-left: 7px;
          cursor: pointer;
        }
        .data_picker {
          width: 100%;
          height: 20px;
          opacity: 0;
          overflow: hidden;
        }
      }
    }
    .table {
      .cell_1 {
        font-size: 12px !important;
        color: #4a4a4a !important;
        font-family: SF-Pro-Display-Heavy !important;
      }
      .cell_2 {
        font-size: 12px;
        color: #171717;
        font-family: SF-Pro-Display-Bold;
        font-weight: 300;
      }
      ::v-deep .el-table .el-table__cell {
        padding: 0;
        font-size: 12px;
        background-color: #f8f8f8;
        font-weight: 300;
        color: #3d3d3d;
      }
      ::v-deep .el-table th.el-table__cell > .cell {
        padding-right: 0;
        line-height: 1.1;
        color: #747474;
        padding: 4px 0 4px 6px;
        word-wrap: break-word;
        word-break: normal;
        font-family: SF-Pro-Display-Bold;
        font-size: 12px;
        font-weight: 300;
      }
      ::v-deep .has-gutter {
        height: auto;
      }
      ::v-deep .el-table__row .el-table__cell .cell {
        color: #707070;
        line-height: 30px;
      }
      ::v-deep .el-table th.el-table__cell.is-leaf {
        border-bottom: 1px solid #e5e5e5;
      }
      ::v-deep .el-table td.el-table__cell,
      .el-table th.el-table__cell.is-leaf {
        // border-bottom: 1px solid transparent;
        border-bottom: 1px solid #e5e5e5;
      }
    }
  }
}
</style>
